import { render, staticRenderFns } from "./Certidoes.vue?vue&type=template&id=029fd159&"
import script from "./Certidoes.vue?vue&type=script&lang=js&"
export * from "./Certidoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports